// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_array-species-create.js
 ** module id = ./node_modules/core-js/library/modules/_array-species-create.js
 ** module chunks = 0
 **/